import {setElementOnClick} from '../ui_utils/DomUtils'
import {UIScrollController} from './UIScrollController'

export class UISingletonScrollController extends UIScrollController {
    constructor(containerId?: string) {
        const container = containerId ? document.getElementById(containerId) as HTMLDivElement : document

        const contentDiv = container.querySelector('.content_singleton_page') as HTMLDivElement
        const sidebarDiv = container.querySelector('.singleton_page_sidebar') as HTMLDivElement
        super(contentDiv, sidebarDiv)

        contentDiv?.addEventListener('scroll', () => this.onContentScroll())
        setElementOnClick(sidebarDiv, (event: MouseEvent) => this.onSidebarClick(event))
    }
}
